<app-iota-modal i18n-title title="Select products" [modalOptions]="modalOptions" (close$)="onCancelClick()">
    <div modal-body>
        <app-filter i18n-placeholder placeholder="Filter products..." (filterValueChange)="applyFilter($event)"></app-filter>

        <div class="alert alert-error shadow-lg mt-2" *ngIf="error()">
            <div class="w-full flex flex-row gap-4">
                <iota-icon icon="information-circle" size="1.5"></iota-icon>
                <span i18n>Error loading products!</span>
                <div class="flex-1"></div>
                <button class="btn btn-primary" (click)="reloadProducts()" i18n>Reload products</button>
            </div>
        </div>

        <app-smart-table
            *ngIf="!error()"
            class="overflow-x-auto overflow-y-hidden"
            [tableHeaderAndData]="table()"
            [loading]="loading()"
            [customContentTemplate]="customContentTemplate"
            [defaultSorting]="{ active: 'name', direction: 'asc' }"
            [firstColumnIsSticky]="false"
            emptyTableText="No products found."
            i18n-emptyTableText
        >
            <ng-template #customContentTemplate let-row="row" let-key="key">
                <input
                    *ngIf="key === 'selected'"
                    type="checkbox"
                    class="checkbox checkbox-primary"
                    [checked]="row[key]?.rawData"
                    (change)="toggleSelection(row)"
                />
            </ng-template>
        </app-smart-table>
    </div>

    <div modal-footer class="flex grow justify-between">
        <div class="flex-1"></div>
        <button class="btn btn-primary" (click)="onSaveClick()" i18n>Apply selection</button>
    </div>
</app-iota-modal>
